// Filled from the repo root .env.local by vite.config.ts. Empty until `bunx convex dev` has run once.
export const convexUrl = import.meta.env.VITE_CONVEX_URL as string;
export const convexSiteUrl = import.meta.env.VITE_CONVEX_SITE_URL as string;

// Where Settings, Desktop app sends people for the installer. Unset: the download reads "Coming soon".
export const desktopDownloadUrl = (import.meta.env.VITE_DESKTOP_DOWNLOAD_URL as string | undefined) || null;
